import { useEffect,useState } from "react";
import Input from "../../../../../GlobalComponents/Input";
import { UseContentManager } from "../../../Library/UseContentManager";
import UseFormHandle from "../../../../../GlobalHooks/UseFormHandle";
import Button from "../../../../../GlobalComponents/Button";
import { useTranslation } from "react-i18next";
import responziveIcon from "../../../../../Media/Images/Icons/responsive.webp";
import InputCard from "../../../../../GlobalComponents/InputCard";
import TopCategoriesResponziveSettings from "./TopCategoriesResponziveSettings";
import { GetTabsForResponsiveDesign } from "../../../Library/functions";
import { TOP_CATEGORIES } from "../../../Library/elements";
import categoryIcon from '../../../../../Media/Images/Icons/category.webp';
import cancelIcon from '../../../../../Media/Images/Icons/cancel.webp';
import List from "../../../../../GlobalComponents/List/List";
import UseEditTopCategories from "../../../Library/UseEditTopCategories";
import ChooseCategories from "../../../../Eshop/Components/Products/ChooseCategories";
import Error from "../../../../../GlobalComponents/Error";

const TopCategoriesSettings = () => {

    const [showAddCategories, SetShowAddCategories] = useState(false);

    const {t} = useTranslation();
    const {formData,SetFormData,SetCompleteFormData,FillFormSelectedItemsWithObj,RemoveFormDataSelectedItems} = UseFormHandle(TOP_CATEGORIES.topCategories); 
    const {
        formData:cmFormData,
        showSettingsElement,
        GetSettings,
        SetSettings,
        RemoveElement,
        ClearSelection
    } = UseContentManager();

    const {
        headerData,
        content,
        loading,
        error,
        GetSelectedCategories
    } = UseEditTopCategories(cmFormData.selectedLang,formData.selectedCategories);

    useEffect(() => {

        const GetSelCategories = async () => {
            const settings = GetSettings(showSettingsElement.index,"topCategories");
            settings.selectedCategories = await GetSelectedCategories(settings.selectedCategories);
            SetCompleteFormData(settings);
        }

        if(showSettingsElement)
            GetSelCategories();

    },[showSettingsElement])

    useEffect(() => {

        var selectedCategories = [];
        for(let val of formData.selectedCategories)
        {
            selectedCategories.push(val.linkID);
        }

        SetSettings(showSettingsElement.index,"selectedCategories",selectedCategories,"topCategories");

    },[formData.selectedCategories])

    const SetS = (e) => {
        SetFormData(e);
        SetSettings(showSettingsElement.index,e,null,"topCategories");
    }

    const RemoveElm = () => {
        RemoveElement(showSettingsElement.index,"topCategories");
        ClearSelection();
    }

    const responziveTabs = GetTabsForResponsiveDesign({
        XL : <TopCategoriesResponziveSettings size = "XL" formData = {formData} OnChange = {(e) => SetS(e)} />,
        LG : <TopCategoriesResponziveSettings size = "LG" formData = {formData} OnChange = {(e) => SetS(e)} />,
        MD : <TopCategoriesResponziveSettings size = "MD" formData = {formData} OnChange = {(e) => SetS(e)} />,
        SM : <TopCategoriesResponziveSettings size = "SM" formData = {formData} OnChange = {(e) => SetS(e)} />,
        XS : <TopCategoriesResponziveSettings size = "XS" formData = {formData} OnChange = {(e) => SetS(e)} />,
        XXS : <TopCategoriesResponziveSettings size = "XXS" formData = {formData} OnChange = {(e) => SetS(e)} />,
    });

    return(
        <>

            <div className="form-group">
                <InputCard
                    className = "form-group"
                    title = {t("Categories")}
                    icon = {categoryIcon}
                    noBodyPadding = {true}
                    headerChildren = {
                        <Button 
                            OnClick = {(e) => {
                                e.stopPropagation();
                                SetShowAddCategories(true)
                            }}
                            className="btn-primary narrow"
                        >{content && content.length > 0 ? t("Edit") : t("Choose")}</Button>
                    }
                >   
                    {error ? 
                        <Error text={error} />
                    :
                        <List 
                            headerData = {headerData} 
                            headerClassName = {"no-top-border"}
                            contentData = {content}
                            isSortable = {false}
                            loading = {loading}
                            replaceDotsImg = {cancelIcon}
                            ReplaceDotsOnClick = {(data) => RemoveFormDataSelectedItems("selectedCategories","linkID",[data.rowID])}
                        />
                    }
                </InputCard>
                {showAddCategories ? 
                    <ChooseCategories 
                        formData = {formData}
                        useDeletedAttribute = {false}
                        SetShowAddCategories = {SetShowAddCategories}
                        FillFormSelectedItemsWithObj = {FillFormSelectedItemsWithObj}
                    />
                :null}
            </div>
            
            <div className="form-group">
                <label>{t("ClassName")}</label>
                <Input 
                    type = "text"
                    name = "className"
                    value = {formData.className}
                    OnChange = {(e) => SetS(e)}
                />
            </div>
                
            <div className="form-group">
                <InputCard
                    title = {t("ResponziveData")}
                    icon = {responziveIcon}
                    tabsData = {responziveTabs}
                />
            </div>
            
            <div className="cm-remove-section-elm">
                <Button 
                    className="btn-brown"
                    OnClick = {() => RemoveElm()}
                >
                    {t("RemoveElement")}
                </Button>
            </div>
        </>
    )
}

export default TopCategoriesSettings;